<template>
  <div class="bubble">
    <bubble-controls
      class="bubble-controls-container"
      :tabs="tabs"
      :categories="categories"
      @tab="updateTab"
      @category="updateCategory"
      @show-count="updateShowCount"
    />

    <div class="row bubble-chart-container">
      <div class="col-xs-12 col-12 col-sm-12">
        <bubble-chart
          v-if="data"
          :years="years"
          :countries="countries"
          :tab="tab"
          :category="category"
          :data="data"
          :showCount="showCount"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { csv } from 'd3';
import BubbleControls from './BubbleControls.vue';
import BubbleChart from './BubbleChart.vue';

export default {
  name: 'Bubble',
  components: {
    BubbleControls,
    BubbleChart,
  },
  data: () => ({
    tab: 'New FinTech firms by year',
    tabs: ['New FinTech firms by year', 'Total FinTech firms in operation by year'],
    category: 'Total Firms',
    showCount: false,
    categories: [],
    years: [],
    countries: [],
    data: null,
    rawData: null,
    dataSrc: `${process.env.BASE_URL}data/bubble.csv`,
  }),
  methods: {
    updateCategory(category) {
      this.category = category;
      this.formatData();
    },
    updateTab(tab) {
      this.tab = tab;
    },
    updateShowCount(showCount) {
      this.showCount = showCount;
    },
    /**
     * Special method to sort categories.
     * Total firms must be in the first order.
     */
    sortCategories() {
      const categories = this.objectsArrayUnique(this.rawData, 'Category', true, 'asc');
      const totalFirmsIndex = categories.findIndex((v) => v === 'Total Firms');
      if (totalFirmsIndex || totalFirmsIndex !== -1) {
        categories.splice(totalFirmsIndex, 1);
        categories.unshift('Total Firms');
      }
      this.categories = categories;
    },
    formatData() {
      this.data = this.rawData
        .filter((d) => this.category === d.Category)
        .map((val) => {
          return {
            id: `${val.Country}-${val.Year}`.replace(/ /g, ''),
            ...val,
          };
        });
    },
    /**
     * Filters an array of objects by unique key and converts into 1 level array.
     * @param {Array} data
     * @param {string} key
     * @param {boolean} sort
     * @param {string} orderBy asc | desc
     */
    objectsArrayUnique(data, key, sort = false, orderBy = 'asc') {
      const flags = [];
      let output = [];

      data.forEach((d) => {
        if (flags[d[key]]) return;
        flags[d[key]] = true;
        output.push(d[key]);
      });

      if (sort) {
        output = output.sort();
        if (orderBy === 'desc') {
          output = output.reverse();
        }
      }

      return output;
    },
  },
  async mounted() {
    const rawData = await csv(this.dataSrc);
    delete rawData.columns;
    this.rawData = rawData;
    this.sortCategories();
    this.years = this.objectsArrayUnique(rawData, 'Year', true, 'asc');
    this.countries = this.objectsArrayUnique(rawData, 'Country', true, 'desc');
    this.formatData();
  },
};
</script>

<style lang="scss" scoped>
.bubble {
  &-controls-container {
    padding-bottom: 30px;
  }
}
</style>
